import Box from "@mui/material/Box";

const ChatWarning = () => {
  return (
    <Box
      sx={{
        "& h4": {
          margin: 0,
          marginTop: 2,
        },
        "& p": {
          margin: 0,
        },
        "& ul": {
          marginTop: 1,
        },
        backgroundColor: "#FFE0B2",
        borderRadius: "8px",
        fontSize: "14px",
        px: 2,
        py: 2,
      }}
    >
      <b>Caution:</b> AI may generate inaccurate information. Please verify important content with relevant experts.
    </Box>
  );
};

export default ChatWarning;
